/** @jsx jsx */
import { jsx } from '@emotion/core'
import { FunctionComponent, ButtonHTMLAttributes } from 'react'
import { styles } from './styles'

interface ButtonProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  color?: 'default' | 'info' | 'danger'
}

export const Button: FunctionComponent<ButtonProps> = ({
  color = 'default',
  ...props
}) => <button {...props} css={[styles.button, styles.colors[color]]}></button>
